import InventoryImportModal from './InventoryImportModal';

export default InventoryImportModal;
